// #region Imports

import * as $ from 'jquery';

// #endregion Imports

// #region Exports

export function initialize(): void {
    wireEvents();
}

// #endregion Exports

// #region Private functions

function wireEvents(): void {
    $('.xml_content').on('selectstart', onSelectStart);
    document.addEventListener('mouseup', onMouseUp);
}

function onSelectStart() {
    $('.js-block-selection').each(function() {
        const $this = $(this);
        $this.addClass($this.data('block-class'));
    });
}

function onMouseUp() {
    $('.js-block-selection').each(function () {
        const $this = $(this);
        $this.removeClass($this.data('block-class'));
    });
}

// #endregion Private functions

